// Derive the right HTML input config for a normalized measurable (Task 1 shape).
export function measurableInputProps(m) {
  if (m.valueType === 'enum') {
    return { kind: 'enum', options: m.enumOptions || [] };
  }
  const hasPrecision = m.precision != null && m.precision !== 0;
  const step = hasPrecision ? m.precision : (m.valueType === 'integer' ? 1 : 0.01);
  return {
    kind: 'number',
    step,
    min: m.min != null ? m.min : undefined,
    max: m.max != null ? m.max : undefined,
  };
}
